var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-link"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.goBackToTarget($event)}}},[_vm._t("text",[_c('IxRes',[_vm._v("frs.common.back")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }